import React, { useState, useEffect, useContext, useRef } from 'react';

import loadBodyContent from './ProductModalContentWrapper.jsx';
import { Modal } from 'web-store-modules/packages/web-store-ui-library';
import { ProductModalContext } from '../../ProductModalContext.jsx';

import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { ComponentTypes } from '../util/ProductModalEnums.js';
import { Button } from 'web-store-modules/packages/web-store-ui-library'

const { reactRoot } = require('../../../../../../../../variables/Variables.js');
import './ProductModal.css';
import ProductModalCartOverlay from './ProductModalCartOverlay.jsx';
import { Scrollbars } from 'react-custom-scrollbars';
import SizeGuide from './size-guide/SizeGuide.jsx';

const isMobile = isMobileDevice();

// Arrays that determine the load order of modal content
const headerLoadOrder = [ComponentTypes.PRODUCT_IMAGE,ComponentTypes.PRODUCT_WISHLIST_BTN];
const bodyLoadOrder = [ComponentTypes.TITLE, ComponentTypes.PRICE, ComponentTypes.SALE_PRICE, ComponentTypes.COLOR_SELECTOR, ComponentTypes.PRODUCT_BUTTONS];

const preventDefault = (e) => e.preventDefault();

const ProductModal = ({ onClose, isMall, renderProductContent, footer, setRelatedProducts }) => {
    const { setModalOpened, isLoading, primaryColor, detailsActive, showingAddToCartPrompt, focusMode, contentHeight, setContentHeight, showSizeGuide, setShowSizeGuide } = useContext(ProductModalContext);
    const [hidePinchTip, setHidePinchTip] = useState(!!sessionStorage.getItem('hidePinchTip'));
    const contentContainer = useRef();
    const animationType = isMall ? 'blur' : 'flyup'

    // TODO: Populate styles from product modal context, possibly taken from CMS settings
    const closeIconStyle = { width: '2.8em', position: 'absolute', backgroundColor: 'transparent', right: '13px', top: '13px', filter: 'Invert(100%)', visibility: focusMode ? 'hidden' : 'visible' };
    const productModalContainerStyle = {
        height: focusMode ? '100vh' : isMobile ? `${document.getElementById(reactRoot).offsetHeight * .85}px` : `${document.getElementById(reactRoot).offsetHeight * .80}px`,
        width: focusMode ? '100vw' : isMobile ? '85vw' : '23em',
        padding: focusMode ? '0' : !footer ? '1em 1em 0' : '0em',
        fontWeight: '400',
        maxHeight: '635px'
        // backgroundColor
    };

    useEffect(() => {
        setContentHeight(contentContainer.current.clientHeight);
        // We use native DOM manipulation here because the react onTouchMove event listener isn't preventing defaults
        if (!hidePinchTip) {
            setTimeout(() => {
                setHidePinchTip(true);
                // If a user doesn't pinch to zoom within two seconds. hide pinch tooltip for the rest of the session, 
                // this is to prevent spamming the user with this tooltip
                if (!sessionStorage.getItem('hidePinchTip')) {
                    sessionStorage.setItem('hidePinchTip', true);
                }
            }, 2000);
            document.addEventListener('touchmove', hideOnPinch, { passive: false });

            // Event Listener is targeting a specific option in addEventListener to disable
            // Mousewheel affects zoom in Safari (Desktop)
            // All event listeners use a shared preventDefault function so that the removeEventListener calls have a specific function to remove
            //document.addEventListener('mousewheel', preventDefault, { passive: false });
            // False sets useCapture to false, handler will only be called during bubbling phase
            // Prevents zoom in iOS Safari when Modal is open
            document.addEventListener('touchmove', preventDefault, false);
            // Disables pinch to zoom on Safari w/ macOS trackpad
            document.addEventListener('gesturestart', preventDefault);
            document.addEventListener('gesturechange', preventDefault);
            document.addEventListener('gestureend', preventDefault);

            return function cleanUp() {
                document.removeEventListener('touchmove', hideOnPinch, { passive: false });
                //document.removeEventListener('mousewheel', preventDefault, { passive: false });
                document.removeEventListener('touchmove', preventDefault, false);
                document.removeEventListener('gesturestart', preventDefault);
                document.removeEventListener('gesturechange', preventDefault);
                document.removeEventListener('gestureend', preventDefault)
            };
        }
        setShowSizeGuide(false)
    }, []);

    const closeModal = () => {
        setRelatedProducts([]);
        onClose()
    }

    const hideOnPinch = (e) => {
        if (hidePinchTip && e.touches.length === 2) {
            sessionStorage.setItem('hidePinchTip', true);
            setHidePinchTip(true);
            e.preventDefault();
        } else if (e.touches.length > 1) {
            e.preventDefault();
        }
    }

    return (
        <Modal animationType={animationType} setModalOpened={setModalOpened} onClose={closeModal} reactRootId={reactRoot} closeIconStyle={closeIconStyle} isLoading={isLoading} wrapperStyle={{ backgroundColor: focusMode ? 'rgba(0, 0, 0, 1)' : 'rgb(255, 255, 255)' }} closeContainerStyle={{right: "-15px", top: "-12px", width: '2.8em', height: '2.8em',position: 'absolute',float: 'right',zIndex: 210}}>
            {/* {showingAddToCartPrompt && <ProductModalCartOverlay isMobile={isMobile} />} */}
            <div id="product-modal-container" className='flex' style={{ ...productModalContainerStyle, opacity: (showSizeGuide ? '0' : '1'), transform: (showSizeGuide ? 'translateY(-122%)' : 'translateY(0)'), height: (showSizeGuide ? '0' : productModalContainerStyle.height) }}>
                <Scrollbars autoHide>
                    <div id="product-modal-header" className="flex" style={{display: focusMode ? 'none' : 'flex'}}>
                        {renderProductContent(headerLoadOrder)}
                    </div>
                    <div id="product-modal-content" ref={contentContainer} style={{ height: 'auto' }}>
                        <div id='product-modal-transition-wrapper' style={{ minHeight: '240px', overflowY: isMobile ? 'auto' : 'hidden' }}>
                            <div className='carousel-container carousel-container-title'>
                                {renderProductContent([ComponentTypes.TITLE])}
                            </div>
                            <div className='product-details'>
                                <div className="priceBox" style={{ marginTop: '10px', float: 'left', color: '#001e42' }}>
                                    {renderProductContent([ComponentTypes.PRICE, ComponentTypes.SALE_PRICE])}
                                </div>

                                <div className='product-features'>
                                    <div className="column size">
                                        {/* {renderProductContent([ComponentTypes.COLOR_SELECTOR])} */}
                                        {renderProductContent([ComponentTypes.SIZE_SELECTOR])}
                                        {renderProductContent([ComponentTypes.CUSTOM_WIDTH])}
                                        {renderProductContent([ComponentTypes.QTY_SELECTOR])}
                                    </div>
                                    {renderProductContent([ComponentTypes.PRODUCT_DETAILS])}
                                </div>
                                {renderProductContent([ComponentTypes.CURATED_SECTION])}
                            </div>
                        </div>
                    </div>
                </Scrollbars>
                <div className='collapsedButtons'>
                    {renderProductContent([ComponentTypes.PRODUCT_BUTTONS_NEW])}
                </div>
            </div>
          {showSizeGuide &&   <div id="product-ar-modal" className='flex' style={{ ...productModalContainerStyle, width:(isMobile) ? '85vw' : (setShowSizeGuide) ? '48em' : '23em', maxHeight : (isMobile) ? '635px' : '700px', opacity: (showSizeGuide ? '1' : '0'), transform: (showSizeGuide ? 'translateY(0)' : 'translateY(100%)'), height: (!showSizeGuide ? '0' : productModalContainerStyle.height) }}>
                <SizeGuide onClose={onClose} setShowSizeGuide={setShowSizeGuide} />
            </div>}
        </Modal >
    );
}

export default loadBodyContent(ProductModal);